import Icon from '@atoms/Icon/Icon';

interface IVideoButton {
  readonly videoSource?: string;
  readonly videoConfig?: string;
  readonly playButtonLabel: string;
  readonly darkFont: boolean;
  readonly onClick?: () => void;
}

export const VideoButton = ({
  videoSource,
  videoConfig,
  playButtonLabel,
  darkFont,
  onClick,
}: IVideoButton) => {
  let qbrickAttrs = {};

  if (videoSource && videoConfig) {
    qbrickAttrs = {
      'data-video': videoSource,
      'data-qbrick-config': videoConfig,
      'aria-controls': 'modal-video',
    };
  }
  return (
    <button
      {...qbrickAttrs}
      onClick={onClick}
      className="tw-mx-auto tw-w-[60px] tw-rounded-full tw-shadow-black tw-transition-shadow hover:tw-shadow-xl"
    >
      <span className="sr-only">{playButtonLabel}</span>
      <Icon
        name="play-button"
        size={64}
        colorClassName={darkFont ? 'tw-text-grey-100' : 'tw-text-white'}
      />
    </button>
  );
};
